import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import swal from 'sweetalert';

import CRMApi from '../../../Api/CRM/CRMApi';
import ManualNotification from '../../../Api/Models/ManualNotification';
import Card from '../../elements/common/Card';
import handleValidationErrors, { ValidationErrors } from '../../helpers/ResponseErrorHelper';
import useBlockingSubmit from '../../hooks/useBlockingSubmit';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';

import NotificationFormFields from './NotificationFormFields';

export default function NotificationUpdate() {
    const history = useHistory();
    const { id } = useNumberParams();
    const [errors, setErrors] = useState<ValidationErrors>({});
    const [endMethod, setEndMethod] = useState<number>(0);
    const [notification, setNotification] = useState<ManualNotification>({} as any);
    const [Submit, submitBlocked] = useBlockingSubmit();

    useOnce(async () => {
        const manualNotification = await CRMApi.manualNotifications.getById(id);
        setNotification(manualNotification);
        setEndMethod(manualNotification.left_to_deliver > 0 || !manualNotification.end_date ? 0 : 1);
    });

    const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        try {
            await CRMApi.manualNotifications.update(
                notification.getNew(endMethod === 0 ? { end_date: undefined } : { left_to_deliver: 0 })
            );
            await swal({ title: 'Success', text: 'Notification updated correctly', icon: 'success' });
            history.push('/notifications');
        } catch (error) {
            handleValidationErrors(error, setErrors);
            submitBlocked(false);
        }
    };

    return (
        <Card>
            <form onSubmit={handleFormSubmit}>
                <NotificationFormFields
                    notification={notification}
                    setNotification={setNotification}
                    endMethod={endMethod}
                    setEndMethod={setEndMethod}
                    errors={errors}
                />
                <Submit label="Update" />
            </form>
        </Card>
    );
}
